<template>
  <div class="againTicketPurchase">
    <div class="order" @click="orderClick">Enter order list</div>
    <div class="again" @click="againBuyingTickets">Book the ticket again</div>
  </div>

</template>

<script>
export default {
  name: "againTicketPurchase",
  props: ['ticketlist','type'],
  methods: {
    againBuyingTickets(){
      this.$router.push(this.ticketlist);
    },
    orderClick(){
      this.$router.push('/orderlistEn/0')
    }
  }
};
</script>

<style scoped lang='less'>
.againTicketPurchase{
  position: fixed;
  width: 100%;
  bottom: 0;
  left: 0;
  background: #3B6D9C;
  line-height: 1.6rem;
  text-align: center;
  color: #FFFFFF;
  font-size: .48rem;
  display: flex;
}
.order {
  flex: 1;
  color: #fff;
  background-color:#81B336;
}
.again {
  flex: 1;
}
</style>
